import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GERENCIAMENTO } from "../../app.config";

@Injectable()
export class ContratosFunpayService {
    headers = new HttpHeaders().set("noloader", "t");

    constructor(private http: HttpClient) { }

    buscar(
        pagina: number,
        itensPorPagina: number,
        referencia: string | null = null,
        motivo: string | null = null,
        assinanteCpf: string | null = null,
        status: number | null = null,
        criadoEmDe: Date | null = null,
        criadoEmAte: Date | null = null
    ) {
        const queryParams = new URLSearchParams({
            Pagina: pagina.toString(),
            ItensPorPagina: itensPorPagina.toString(),
            referencia: referencia ? referencia : "",
            motivo: motivo ? motivo : "",
            assinanteCpf: assinanteCpf ? assinanteCpf : "",
            status: status !== null ? status.toString() : "",
            criadoEmDe: criadoEmDe ? criadoEmDe.toISOString() : "",
            criadoEmAte: criadoEmAte ? criadoEmAte.toISOString() : "",
        });

        return this.http.get<PagedResult<ItemListaContratoFunpay>>(
            `${GERENCIAMENTO}/api/funtrato/contratos?${queryParams.toString()}`,
            {
                headers: this.headers,
            }
        );
    }

    visualizar(id: number) {
        return this.http.get<DetalhesContratoFunpay>(
            `${GERENCIAMENTO}/api/funtrato/contrato/${id}`,
            {
                headers: this.headers,
            }
        )
    }
}

export function formataCPF(cpf: string): string {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formataCNPJ(cnpj: string): string {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function estadoDocumentoToString(estado: number): string {
    switch (estado) {
        case 0:
            return "Pendente";
        case 1:
            return "Assinado";
        case 2:
            return "Rejeitado";
        case 3:
            return "Cancelado";
        case 4:
            return "Em Processamento";
        default:
            return "Desconhecido";
    }
}

export function estadoAssinaturaToString(estado: number): string {
    switch (estado) {
        case 1:
            return "Pendente";
        case 2:
            return "Processamento";
        case 3:
        case 5:
            return "Aprovado";
        case 4:
            return "Em Análise";
        case 6:
        case 7:
            return "Cancelado";
        default:
            return "Desconhecido";
    }
}

export interface PagedResult<T> {
    Items: T[];
    Page: number;
    TotalItems: number;
    TotalPages: number;
    HasPrevious: boolean;
    HasNext: boolean;
}

export interface ItemListaContratoFunpay {
    Id: number;
    Referencia: string;
    Motivo: string;
    CnpjRequerente: string;
    NomeRequerente: string;
    DataCriacao: Date;
    DataAssinatura: Date | null;
    Status: number;
    HashArquivo: string | null;
    ModeloId: number;
    ModeloNome: string;
    Assinaturas: AssinaturaContratoFunpay[];
}

export interface AssinaturaContratoFunpay {
    Id: number;
    DocumentoId: number;
    AssinanteDocumentoId: number;
    Estado: number;
    DataAssinatura: Date | null;
    IpAssinante: string | null;
    LatitudeAssinante: string | null;
    LongitudeAssinante: string | null;
    AssinanteDocumento: AssinanteContratoFunpay;
}

export interface AssinanteContratoFunpay {
    Id: number;
    Nome: string;
    Cpf: string;
    DataNascimento: Date | null;
    Email: string;
    Telefone: string;
}

export interface DetalhesContratoFunpay {
    Id: number;
    Referencia: string;
    Motivo: string;
    CnpjRequerente: string;
    NomeRequerente: string;
    DataCriacao: Date;
    DataAssinatura: Date | null;
    Status: number;
    HashArquivo: string | null;
    ModeloNome: string;
    Assinaturas: AssinaturaContratoFunpay[];
}